import { doc, getDoc } from 'firebase/firestore';
import { getFirebase } from '../firebase/config';
import { ALBUM_ID } from './ids';

export const PLACEHOLDER_SRC = '/default.png';

const cache = new Map<string, Promise<string | null>>();

function toBytes(raw: unknown): Uint8Array | null {
  if (!raw) return null;
  if (raw instanceof Uint8Array) return raw;
  if (raw instanceof ArrayBuffer) return new Uint8Array(raw);
  if (typeof raw === 'object' && raw && 'toUint8Array' in raw) {
    return (raw as { toUint8Array: () => Uint8Array }).toUint8Array();
  }
  return null;
}

export function loadPhotoSrc(photoId: string): Promise<string | null> {
  if (!photoId) return Promise.resolve(null);
  const hit = cache.get(photoId);
  if (hit) return hit;
  const pending = (async () => {
    const { db } = getFirebase();
    const snap = await getDoc(doc(db, 'albums', ALBUM_ID, 'files', photoId));
    if (!snap.exists()) return null;
    const data = snap.data();
    const bytes = toBytes(data.bytes);
    if (!bytes) return null;
    const mime = typeof data.mime === 'string' ? data.mime : 'image/jpeg';
    const copy = new ArrayBuffer(bytes.byteLength);
    new Uint8Array(copy).set(bytes);
    return URL.createObjectURL(new Blob([copy], { type: mime }));
  })();
  cache.set(photoId, pending);
  return pending;
}
